/**
 * Persona-aware dashboard router.
 * ────────────────────────────────
 * The /dashboard route used to render a single Overview.jsx that was
 * holding-company-centric. Wave 3 introduces 4 distinct personas; this
 * shim picks the right one based on the current user's role + tenant.
 *
 *   investor                        → InvestorDashboard
 *   founder / startup_member        → StartupDashboard
 *   tenant === 'alpha-incubator'    → IncubatorDashboard
 *   role  === 'incubator_admin'     → IncubatorDashboard
 *   default (holding_admin etc.)    → HoldingDashboard (the legacy Overview)
 *
 * Maker stays on the Holding view by default (it's the master cockpit) —
 * but the cloak flow naturally puts the Maker on the persona view of
 * whoever they're impersonating.
 */
import React from 'react';
import { useAuth } from '@/context/AuthContext';
import HoldingDashboard from '@/pages/dashboard/Overview';
import InvestorDashboard from '@/pages/dashboard/InvestorDashboard';
import StartupDashboard from '@/pages/dashboard/StartupDashboard';
import IncubatorDashboard from '@/pages/dashboard/IncubatorDashboard';

export default function DashboardRouter() {
  const { user } = useAuth();
  if (!user) return null;

  const role = user.role;
  const tenant = user.tenant_id;

  if (tenant === 'alpha-incubator' || role === 'incubator_admin') {
    return <IncubatorDashboard />;
  }
  if (role === 'investor') {
    return <InvestorDashboard />;
  }
  if (role === 'founder' || role === 'startup_member') {
    return <StartupDashboard />;
  }
  return <HoldingDashboard />;
}
